<template>
  <div>
    <div class="checkbox-wrapper">
      <input type="checkbox" :id="currentId" v-model="model">
      <div
        class="checkbox"
        :class="model ? 'active' : ''"
        @click="() => model = !model"
      >
        <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 5L5 9L13 1" stroke="white" stroke-width="2"/>
        </svg>
      </div>
      <label class="checkbox-label" :for="currentId">
        <slot />
      </label>
    </div>
  </div>
</template>

<script>

export default {
  name: 'square-checkbox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    model: '',
    currentId: `checkbox-${Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)}`,
  }),
  watch: {
    model(oldValue) {
      this.$emit('input', oldValue);
    },
  },
  mounted() {
    this.model = this.checked;
  },
};
</script>

<style lang="scss" scoped>
  .checkbox-wrapper {
    -webkit-tap-highlight-color: transparent;

    display: flex;
    align-items: baseline;
    gap: 8px;

    cursor: pointer;

    label {
      cursor: pointer;
    }
  }

  [id^="checkbox"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkbox {
    box-sizing: border-box;

    width: 24px;
    min-width: 24px;
    max-width: 24px;

    height: 24px;
    min-height: 24px;
    max-height: 24px;

    background-color: #F8FAFC;

    border: 1px solid #CBD5E1;
    border-radius: 4px;

    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    &.active {
      background-color: var(--primary);
    }
  }
</style>
